import RoutesContainer from "./routes";

function App() {
  return (
    <div>
      {/* <h1>React App</h1> */}

      <RoutesContainer />
    </div>
  );
}

export default App;
